import { User } from '@elio/emanager-front/auth/model';
import { PathRouter } from '@elio/emanager-front/shared/tools/router';

/**
 * Redirect user according to its role and the products he manages
 */
const userRedirection = (user: User): PathRouter[] => {
  if (user.isSuperAdmin) {
    return ['admin'];
  } else if (user.headquarters && user.headquarters.length > 0) {
    if ((user.offerIds && user.offerIds.length > 0) || user.headquarters.length > 1) {
      return ['headquarters-menu'];
    } else {
      return ['headquarter', user.headquarters[0].id];
    }
  } else if (user.offerIds && user.offerIds.length > 0) {
    if (user.offerIds.length === 1) {
      return ['offer', user.offerIds[0]];
    } else {
      return ['offer-menu'];
    }
  } else {
    console.warn('User has not any offers nor headquarters.');
    return [{ outlets: { popup: 'offer-empty' } }];
  }
};

export const UserUtils = {
  userRedirection,
};
